<template>
	<AdaptiveContainerWithoutGrid class="relative">
		<div
			class="relative max-w-[1200px] mx-8 md:mx-auto border border-dj-grey-light rounded-big my-12 p-5 md:py-6 md:px-12 bg-white sm:flex items-center"
		>
			<div class="max-w-[700px] md:mr-8">
				<h3 class="text-base text-dj-red">{{ $t("szmd") }}</h3>
				<h2 class="text-xl sm:text-2xl text-dj-red my-2">
					{{ prizes ? $t("szmdCta.title") : $t("szmdNoPrizes.cta.title") }}
				</h2>
				<p
					class="text-sm sm:text-base mb-1"
					v-html="prizes ? $t('szmdCta.copy1', { companies: bannerCompanies }) : $t('szmdNoPrizes.cta.copy1')"
				></p>
				<p
					class="text-sm sm:text-base mb-1"
					v-html="prizes ? $t('szmdCta.copy2') : $t('szmdNoPrizes.cta.copy2')"
				></p>
				<p v-if="prizes" class="text-sm sm:text-base mb-1" v-html="$t('szmdCta.copy3')"></p>
				<BaseLink class="w-[180px] mt-4 mb-3 sm:mb-0 mx-auto sm:mx-0" @click="openSzmdBoxVoteModal()">
					<BaseButton type="primary-red" class="w-full min-h-[40px] max-w-[180px]">
						{{ $t("vote") }}
					</BaseButton>
				</BaseLink>
			</div>
			<img
				class="w-[200px] h-[186px] mx-auto"
				src="https://res.cloudinary.com/djbs/image/upload/v1695647702/content/DreamJobs/Graphics/pic_szmd-cta.png"
			/>
		</div>
	</AdaptiveContainerWithoutGrid>
</template>

<script lang="ts">
import { ref, defineComponent, inject } from "vue";
import { useI18n } from "vue-i18n";

export default defineComponent({
	name: "SzmdCtaBanner",
	setup() {
		const region = ref("");
		const { locale } = useI18n();
		const { bannerCompanies, prizes } = useRuntimeConfig().public.activeConfig.szmdConfig;
		const openSzmdBoxVoteModal = inject("openSzmdBoxVoteModal");

		onMounted(() => {
			region.value = useRegion.getCurrentRegion().code;
		});

		return {
			region,
			locale,
			bannerCompanies,
			prizes,
			openSzmdBoxVoteModal,
		};
	},
});
</script>
